import React from 'react';
import { useGetCmpMemberInvoicesQuery } from '../../../../graphql/types';

export default function MemberInvoiceNavSummary() {
  const { data, error } = useGetCmpMemberInvoicesQuery({
    variables: { input: { limit: 1 } }, fetchPolicy: 'no-cache', pollInterval: 30000,
  });
  if (error || !data) return null;
  const count = data.getCmpMemberInvoices.outstanding.reduce((sum, item) => sum + item.count, 0);
  return <span style={{ display: 'block', fontSize: 12, color: count ? '#ED1C24' : '#15803d' }}>
    {count ? `${count} Outstanding Invoice${count === 1 ? '' : 's'}` : 'All Invoices Paid'}
  </span>;
}
